export interface RevendaUnidade {
  idRevendaEmpreendimento: string;
  idRevendaEmpreendimentoTorre: string;
  idTipoRevenda: string;
  idRevendaCaracteristica: string;
  andar: string;
  unidade: string;
  pronto: boolean | null;
  chaves: boolean | null;
  habitado: boolean | null;
  deposito: boolean | null;
  numeroDormitorios: number;
  numeroSuites: number;
  churrasqueriaVaranda: boolean | null;
  mobiliado: boolean | null;
  valorCondominio: string;
  valorIptu: string;
  areaUtil: string;
  valorUnidade: string;
  valorMetroQuadrado: number;
  saldoDevedor: string;
  observacao: string;
  detalhamento: string;
  revendaStatus: number;
  acompanhamento: string;
  vagas: { id: number; tipoVaga: number | null }[];
  proprietarios: { id: number; nome: string; email: string; celular: string }[];
  nomeCliente: string;
  rgCliente: string;
  vendidoSemNossaIntermediacao: boolean;
  usuarioResponsavel: string;
}

export const defaultRevendaUnidade: RevendaUnidade = {
  idRevendaEmpreendimento: "",
  idRevendaEmpreendimentoTorre: "",
  idTipoRevenda: "",
  idRevendaCaracteristica: "",
  andar: "",
  unidade: "",
  pronto: null,
  chaves: null,
  habitado: null,
  deposito: null,
  numeroDormitorios: 0,
  numeroSuites: 0,
  churrasqueriaVaranda: null,
  mobiliado: null,
  valorCondominio: "",
  valorIptu: "",
  areaUtil: "",
  valorUnidade: "",
  valorMetroQuadrado: 0,
  saldoDevedor: "",
  observacao: "",
  detalhamento: "",
  revendaStatus: 0,
  acompanhamento: "",
  vagas: [
    {
      id: Date.now(),
      tipoVaga: null,
    },
  ],
  proprietarios: [
    {
      id: Date.now(),
      nome: "",
      email: "",
      celular: "",
    },
  ],
  nomeCliente: "",
  rgCliente: "",
  usuarioResponsavel: "",
  vendidoSemNossaIntermediacao: false,
};

export interface RevendaUnidadeCadastrar extends RevendaUnidade {
  authToken: string;
}

export interface RevendaUnidadeEditar extends RevendaUnidadeCadastrar {
  id: string;
}

type DataType = {
  proprietarios: {
    id: number;
    nome: string;
    email: string;
    celular: string;
  }[];
  vagas: { id: number; tipoVaga: number }[];
};

export const revendaDataTemplate: {
  [K in keyof DataType]: () => DataType[K][number];
} = {
  proprietarios: () => ({
    id: Date.now(),
    nome: "",
    email: "",
    celular: "",
  }),
  vagas: () => ({
    id: Date.now(),
    tipoVaga: 0,
  }),
};

export const NumberOptions = Array.from({ length: 11 }, (_, index) => ({
  value: index,
  label: `${index}`,
}));

export enum StatusReserva {
  "Disponivel" = 1,
  "Reservado" = 2,
  "Vendido" = 3,
  "Suspenso" = 4,
}
